"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DD = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Text = require("../Text");

var _excluded = ["children", "className", "variant"];

var DD = function DD(_ref) {
  var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    El: "dd",
    variant: variant || 'mono'
  }, props, {
    className: (0, _classnames["default"])(className, {
      largestrong: variant === 'largestrong'
    })
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1180450048"
  }, ["dd.largestrong{grid-column-start:1;grid-column-end:-1;padding-bottom:12px;}"]));
};

exports.DD = DD;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERCIsImNoaWxkcmVuIiwiY2xhc3NOYW1lIiwidmFyaWFudCIsInByb3BzIiwiY2xhc3NuYW1lcyIsImxhcmdlc3Ryb25nIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGF0YUxpc3QvREQudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgVGV4dCB9IGZyb20gJy4uL1RleHQnO1xuXG5leHBvcnQgY29uc3QgREQgPSAoe1xuICBjaGlsZHJlbixcbiAgY2xhc3NOYW1lLFxuICB2YXJpYW50LFxuICAuLi5wcm9wc1xufTogUmVhY3QuQ29tcG9uZW50UHJvcHM8dHlwZW9mIFRleHQ+KSA9PiAoXG4gIDxUZXh0XG4gICAgRWw9XCJkZFwiXG4gICAgdmFyaWFudD17dmFyaWFudCB8fCAnbW9ubyd9XG4gICAgey4uLnByb3BzfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NuYW1lcyhjbGFzc05hbWUsIHtcbiAgICAgIGxhcmdlc3Ryb25nOiB2YXJpYW50ID09PSAnbGFyZ2VzdHJvbmcnLFxuICAgIH0pfVxuICA+XG4gICAge2NoaWxkcmVufVxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIDpnbG9iYWwoZGQubGFyZ2VzdHJvbmcpIHtcbiAgICAgICAgZ3JpZC1jb2x1bW4tc3RhcnQ6IDE7XG4gICAgICAgIGdyaWQtY29sdW1uLWVuZDogLTE7XG4gICAgICAgIHBhZGRpbmctYm90dG9tOiAxMnB4O1xuICAgICAgfVxuICAgIGB9PC9zdHlsZT5cbiAgPC9UZXh0PlxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7Ozs7QUFFTyxJQUFNQSxFQUFFLEdBQUcsU0FBTEEsRUFBSztFQUFBLElBQ2hCQyxRQURnQixRQUNoQkEsUUFEZ0I7RUFBQSxJQUVoQkMsU0FGZ0IsUUFFaEJBLFNBRmdCO0VBQUEsSUFHaEJDLE9BSGdCLFFBR2hCQSxPQUhnQjtFQUFBLElBSWJDLEtBSmE7RUFBQSxvQkFNaEIsZ0NBQUMsVUFBRDtJQUNFLEVBQUUsRUFBQyxJQURMO0lBRUUsT0FBTyxFQUFFRCxPQUFPLElBQUk7RUFGdEIsR0FHTUMsS0FITjtJQUlFLFNBQVMsRUFBRSxJQUFBQyxzQkFBQSxFQUFXSCxTQUFYLEVBQXNCO01BQy9CSSxXQUFXLEVBQUVILE9BQU8sS0FBSztJQURNLENBQXRCO0VBSmIsSUFRR0YsUUFSSDtJQUFBO0VBQUEsb0ZBTmdCO0FBQUEsQ0FBWCJ9